import BaseStore from './base-store.js'
import {API_ADMIN_USERS} from 'consts/api'
import {API2_USERS} from 'consts/api2'

export class User extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      name: undefined,
      first_name: undefined,
      last_name: undefined,
      title: undefined,
      bio: undefined,
      offering: undefined,
      email: undefined,
      is_admin: undefined,
      is_superuser: undefined,
      is_beta: undefined,
      is_tenant_manager: undefined,
      tenant_id: undefined,
      updating: false,
      ...values
    })
  }

  async doSave(rest, changed) {
    this.updating = true
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(`${API2_USERS}/${this.id}`, to_write)
    this._bleach(bleach)
    this.updating = false
  }

  get groups() {
    const result = []

    if (this.is_admin) result.push('administrators')
    if (this.is_superuser) result.push('superusers')
    if (this.is_beta) result.push('beta')
    if (this.is_tenant_manager) result.push('tenant_manager')

    return result
  }

  get display_name() {
    if (this.first_name || this.last_name) {
      return `${this._state.first_name || ''} ${this._state.last_name || ''}`.trim()
    }
    return this.name
  }
}

export class Users extends BaseStore {
  constructor() {
    super({
      view_items: [],
      view_total: 0,
      total: 0,
    })
  }

  async doLoad(rest, params = {}) {
    const data = await (rest || this._rest).get(API2_USERS, {...params})
    this._state.view_items = data.view_items?.map(user => new User(user))
    this._state.view_total = data.view_total
    this._state.total = data.total
  }

  async loadUser(user_id) {
    const data = await this._rest.get(`${API_ADMIN_USERS}/${user_id}`)
    return new User(data)
  }

  async inviteUser(data) {
    await this._rest.put(`${API_ADMIN_USERS}`, data)
  }

  getUser(id) {
    for(const user of this._state.view_items) {
      if (user.id == id) {
        return user
      }
    }
  }

  replaceUser(user){
    const items = this._state.view_items
    this._state.view_items = items.map(x => x.id === user.id ? user : x)
  }
}

const users = new Users()
export default users
